module.exports = __webpack_public_path__ + "img/RETURN_SALE.94d0ddf6.svg";